import { vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31a647df"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["checked", "name"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__checkbox" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" })
], -1))
const _hoisted_3 = { class: "checkbox__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_form_item = _resolveComponent("app-form-item")!

  return (_openBlock(), _createBlock(_component_app_form_item, {
    label: _ctx.label,
    "control-class": _ctx.controlClass,
    "error-message": _ctx.errorMessage || _ctx.propError
  }, {
    default: _withCtx(() => [
      _createElementVNode("label", {
        class: _normalizeClass(["checkbox", {'checkbox--align-start': _ctx.alignStart}])
      }, [
        _withDirectives(_createElementVNode("input", _mergeProps({
          class: "checkbox__input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event))
        }, _ctx.$attrs, {
          checked: _ctx.checked,
          name: _ctx.name,
          type: "checkbox"
        }), null, 16, _hoisted_1), [
          [_vModelCheckbox, _ctx.value]
        ]),
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ], 2)
    ]),
    _: 3
  }, 8, ["label", "control-class", "error-message"]))
}